import { BaseYup, yup } from 'src/customYup'

export type CommonContentPageFormEntity = {
  name: string
  priority: number
  annotation?: string
  isPublic: boolean
  displayConsumer: boolean
  designFormat: string
  icon: number
}

export type CommonContentAssetFormEntity = {
  name?: string
  url?: string
  priority: number
  fileSize: number
}

export const CommonContentPageFormEntitySchema: yup.SchemaOf<CommonContentPageFormEntity> =
  BaseYup.object({
    name: BaseYup.string().required(),
    priority: BaseYup.number().required(),
    annotation: BaseYup.string(),
    isPublic: BaseYup.boolean().required(),
    displayConsumer: BaseYup.boolean().required(),
    designFormat: BaseYup.string().required(),
    icon: BaseYup.number().required(),
  })

export const CommonContentAssetFormEntitySchema: yup.SchemaOf<CommonContentAssetFormEntity> =
  BaseYup.object({
    name: BaseYup.string(),
    url: BaseYup.string(),
    priority: BaseYup.number().required(),
    fileSize: BaseYup.number().required(),
  })
